<template>
  <div class="dropdown-search">
    <DropDownSelect v-bind="$attrs" v-on="$listeners" class="dropdown-search__select">
      <template v-slot:tn-dropdown-trigger-icon>
        <span
          class="tn-dropdown__trigger-icon"
          :class="{ 'tn-dropdown__trigger-icon--expanded-local': visible }"
        >
          <svg class="dd-icon" viewBox="0 0 24 24">
            <use xlink:href="@/assets/images/dropdown-arrow.svg#caret" />
          </svg>
        </span>
      </template>

      <template v-slot:tn-dropdown-option="{ option }">
        <slot name="tn-dropdown-option" :option="option"> </slot>
      </template>
      <template v-if="$attrs.hasNext" v-slot:tn-dropdown__pagination>
        <div
          @click.stop="$emit('load-more')"
          class="tn-dropdown__options__option tn-dropdown__options__option__pagination"
        >
          +
        </div>
      </template>
    </DropDownSelect>
  </div>
</template>

<script>
import DropDownSelect from '@thinknimble/dropdownselect'

export default {
  name: 'DropDownSearch',
  components: { DropDownSelect },
  watch: {},
  computed: {
    // this is not the right way to do this (the component needs to be updated to pass back the event)
    // TODO: PB 11/02/2020 this is just a temp fix
    visible() {
      return this.$children[0].visible
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .tn-dropdown__options__container {
  background-color: $stain;
}

::v-deep .tn-dropdown__options__container:hover,
::v-deep .tn-dropdown__selection-container:hover {
}

::v-deep .tn-dropdown__selection-container {
  border: none;
}
::v-deep .tn-dropdown__selection-container {
  .tn-dropdown__search {
    &:focus {
    }
  }
}
::v-deep .tn-dropdown {
}

::v-deep .tn-dropdown__trigger-icon {
  width: 24px;
  height: 24px;
  > svg {
    transform: rotate(-90deg);
  }
}

::v-deep .tn-dropdown__selected-items--multi__item {
}
</style>
